import React, { createRef, useRef } from 'react';

import {
  DropdownDescription,
  Options,
  SelectValueWrap,
} from '@components/dataEntry/select/selectorStyle';
import KeyDownScrollWrapper from '@components/wrapper/KeyDownScrollWrapper';
import Avatar from '@components/dataDisplay/Avatar';

interface Props {
  maxHeight?: number;
  // 개선중
  isOpen: boolean;
  filteredList: any;
  handleSelect: (index?) => void;
  activeIndex: number | null;
  setActiveIndex: any;
  showDescription?: boolean;
  id?: string;
}

function ResultDropdown({
  maxHeight = 100,
  isOpen,
  filteredList,
  handleSelect,
  activeIndex,
  setActiveIndex,
  showDescription = true,
  id,
}: Props) {
  const refs: any = useRef(
    Array.from({ length: filteredList ? filteredList.length : 0 }, () =>
      createRef(),
    ),
  );

  return (
    <KeyDownScrollWrapper
      listMaxLength={filteredList ? filteredList.length - 1 : 0}
      name={id || 'hashtag-result'}
      maxHeight={maxHeight}
      activeIndex={activeIndex}
      handleEnter={handleSelect}
      setActiveIndex={setActiveIndex}
      open={isOpen}
    >
      <>
        {filteredList &&
          filteredList!.map((list, index) => {
            const { title, value, description, thumbnail, imgURL } = list;

            return (
              <Options
                key={index}
                ref={refs.current[index]}
                isActiveIndex={activeIndex === index}
                onClick={(e) => {
                  e.preventDefault();
                  handleSelect(index);
                }}
                tabIndex={0}
              >
                <SelectValueWrap>
                  {(thumbnail || imgURL) && (
                    <Avatar photoURL={thumbnail || imgURL} size="20px" />
                  )}
                  {title || value}
                </SelectValueWrap>
                {showDescription && description && (
                  <DropdownDescription>{description}</DropdownDescription>
                )}
              </Options>
            );
          })}
      </>
    </KeyDownScrollWrapper>
  );
}

export default ResultDropdown;
